import script from "./BeamTable.vue?vue&type=script&setup=true&lang=js"
export * from "./BeamTable.vue?vue&type=script&setup=true&lang=js"

import "./BeamTable.vue?vue&type=style&index=0&id=7e5caa2b&lang=css"
import "./BeamTable.vue?vue&type=style&index=1&id=7e5caa2b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7e5caa2b"]])

export default __exports__